import Link from 'next/link';
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from '@heroicons/react/20/solid';
import cx from 'classnames';

interface PaginationProps {
  hasPreviousPage: boolean;
  page: number;
  numPages: number;
  hasNextPage: boolean;
  basePath: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  hasPreviousPage,
  page,
  numPages,
  hasNextPage,
  basePath,
}) => (
  <nav className="flex items-center justify-between border-t border-gray-200 px-4 sm:px-0">
    <div className="-mt-px flex w-0 flex-1">
      {hasPreviousPage && (
        <Link
          href={`${basePath}${page <= 2 ? '' : `/${page - 1}`}`}
          rel="prev"
          className="inline-flex items-center border-t-2 border-transparent pt-4 pr-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        >
          <ArrowLongLeftIcon
            className="mr-3 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
          Previous
        </Link>
      )}
    </div>
    {numPages > 1 && (
      <div className="hidden md:-mt-px sm:flex">
        {[...new Array(numPages)].map((_item, index) => (
          <Link
            key={index}
            href={`${basePath}${index === 0 ? '' : `/${index + 1}`}`}
            className={cx(
              'inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium',
              {
                'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300':
                  page !== index + 1,
                'border-blue-500 text-blue-600': page === index + 1,
              },
            )}
          >
            {index + 1}
          </Link>
        ))}
      </div>
    )}
    <div className="-mt-px flex w-0 flex-1 justify-end">
      {hasNextPage && (
        <Link
          href={`${basePath}/${page + 1}`}
          rel="next"
          className="inline-flex items-center border-t-2 border-transparent pt-4 pl-1 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700"
        >
          Next
          <ArrowLongRightIcon
            className="ml-3 h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </Link>
      )}
    </div>
  </nav>
);
